import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDino: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconDino"><Path d="M16.5 5V11.4861H16.25C9.05186 7.08765 7.15772 11.0627 5.36892 14.8167C4.23183 17.203 3.13731 19.5 0.75 19.5H6.5V21.5H9.5V19.5H13.5V21.5H16.5V18.6973C18.2934 17.6599 19.5 15.7208 19.5 13.5V7L21.5 5.97222V5C21.5 3.61929 20.3807 2.5 19 2.5C17.6193 2.5 16.5 3.61929 16.5 5Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconDino;
